import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoggedInGuard } from '../auth/auth.guards';
import { EmailCompletionComponent } from './completion/completion.component';

const routes: Routes = [
  {
    path: "",
    canActivate: [LoggedInGuard],
    runGuardsAndResolvers: "always",
    data: { 
      sidebar: "email-completion",
      title: "Email Completion"
    },
    component: EmailCompletionComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmailCompletionRoutingModule { }

const emailCompletionModuleLazyLoadRoutes: Routes = [
  {
    path: 'email-completion',
    loadChildren: () => import('./email-completion.module').then(m => m.EmailCompletionModule),
  },
];

export { emailCompletionModuleLazyLoadRoutes };